import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";

import mockData from "../mockData";

const extendedFieldsApi = {
  /**
   * @param {object} param0
   * @param {number} param0.groupId
   * @param {number} param0.signupItemId
   */
  getExtendedFields: ({ groupId, signupItemId }) => {
    if (groupId) return new FnrFetch3(`/group/${groupId}/getExtendedFields`);
    return mockData.shouldMock
      ? callMockResponse(() => mockData.getExtendedFields)
      : new FnrFetch3(`/signupList/getExtendedFields`, {
          signupListItemID: signupItemId,
        });
  },
  /**
   * @param {object} param0
   * @param {number} param0.groupId
   * @param {number} param0.signupItemId
   * @param {object} postData
   */
  updateExtendedFieldOrder: ({ groupId, signupItemId }, postData) => {
    if (groupId)
      return new FnrFetch3(
        `/group/${groupId}/updateExtendedFieldOrder`,
        postData
      );
    return new FnrFetch3(`/signupList/updateExtendedFieldOrder`, {
      ...postData,
      signupListItemID: signupItemId,
    });
  },
  /**
   * @param {object} param0
   * @param {number} param0.groupId
   * @param {number} param0.signupItemId
   * @param {object} param0.payload
   */
  enableExtendedField: ({
    groupId,
    payload, // Note that payload is pass like this instead of as a second arg so that the interface is the same as createExtendedField,
  }) => {
    if (groupId)
      return new FnrFetch3(`/group/${groupId}/enableExtendedField`, payload);
    else return new FnrFetch3(`/signupList/enableExtendedField`, payload);
  },
  /**
   * @param {object} param0
   * @param {object} param0.payload
   */
  createExtendedField: ({ payload }) =>
    new FnrFetch3(`/extendedfield/create`, payload),
  /**
   * @param {object} param0
   * @param {number} param0.groupId
   * @param {number} param0.signupItemId
   * @param {object} postData
   */
  disabledExtendedField: ({ groupId, signupItemId }, postData) => {
    if (groupId)
      return new FnrFetch3(`/group/${groupId}/disableExtendedField`, postData);
    else
      return new FnrFetch3(`/signupList/disableExtendedField`, {
        ...postData,
        signupListItemID: signupItemId,
      });
  },
  /**
   * @param {number} networkFieldID
   */
  getGroupsWithNetworkField: (networkFieldID) =>
    new FnrFetch3(
      `/extendedfield/getGroupsWithNetworkField?networkFieldID=${networkFieldID}`
    ),
};

export default extendedFieldsApi;
